import consts from "@/consts.js";
import Request from './request';
import store from "@/store";
import snackbar from "@/plugins/snackbar";
import i18n from "@/i18n";

async function fetch(data) {// 获取单个
    return Request('get', "api/alliance-businesses/" , data);
}
async function fetchOne(id) {// 获取单个
    return Request('get', "api/alliance-businesses/" + id);
}

async function fetchAll(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/alliance-businesses", data);
}

async function fetchAllForSelect(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    data.fieldFilter = ["id", "alliance_business_code", "alliance_business_name",]; //仅筛选少许必要字段
    return Request('get', "api/alliance-businesses/select", data, false, false, true);
}

async function save(id,data) {// 编辑或新建数据（有id为编辑，没有id为新建）
    if (id) {
        return Request('post', "api/alliance-businesses/edit?id=" + id, data);
    } else {
        return Request('post', "api/alliance-businesses/add" , data);
    }
}

async function getWxQrCode(Id) {
    return Request('get', "api/alliance-businesses/get-wx-qr-code/" + Id);
}

async function exportExcel(data) {// 销售导出
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/alliance-businesses/export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

export default {
    fetch,
    fetchOne,
    fetchAll,
    fetchAllForSelect,
    save,
    getWxQrCode,
    exportExcel,
};